















































































































































































































import * as courseAPI from '@adobe/edex/frontend/api/course';
import { mapState } from 'vuex';
import { debounce } from 'lodash-es';

import { sortOptions, statusOptions, pageLimitOptions } from '@adobe/edex/frontend/views/course/manage/constants';
import Pagination from '@adobe/edex/frontend/views/course/manage/numbered-pagination.vue';
import TableRow from '@adobe/edex/frontend/views/course/manage/course-manage-row.vue';
import BulkActions from '@adobe/edex/frontend/views/course/manage/course-manage-bulk-actions.vue';
import EnrollMember from '@adobe/edex/frontend/views/course/manage/course-manage-enroll-member.vue';
import Select from '@adobe/edex/frontend/views/course/manage/course-manage-select.vue';
import ProgressModal from '@adobe/edex/frontend/views/course/manage/course-manage-progress-modal.vue';
import { paginateMixin } from '@adobe/edex/frontend/mixins/paginate';
import '@adobe/edex/ui/shared/components/dialog-next/import-result-dialog';
import '@adobe/edex/ui/shared/components/dialog-next/import-details-dialog';

export default {
  data() {
    return {
      enrollees: null,
      selected: new Set(),
      showEnrollMember: false,
      showSort: false,
      showStatus: false,
      showLimit: false,
      error: false,
      searchTerm: '',
      lastSearch: '',
      sort: '',
      status: '',
      enrollmentJson: '{}',
      flagged: false,
      limit: 25,
      page: 1,
      offset: 0,
      maxPage: 1,
      bulkErrors: 0,
      exportLoading: false,
      exportError: false,
      importLoading: false,
      openImportDetailsDialog: false,
      openPassResultDialog: false,
      reportUrl: '',
      enrollmentUpdateReportUrl: '',
      totalEnrollmentUpdateAttempted: 0,
      successEnrollmentUpdate: 0,
      failedEnrollmentUpdate: 0,
      sortOptions,
      statusOptions,
      pageLimitOptions,
    };
  },
  components: {
    TableRow,
    BulkActions,
    EnrollMember,
    Pagination,
    Select,
    ProgressModal,
  },
  mixins: [paginateMixin],
  async created() {
    this.checkPermissions();
    this.onTextSearch = debounce(this.onTextSearch, 300);
    await this.list();
  },
  beforeRouteEnter(_, __, next) {
    return next((vm: any) => {
      vm.checkPermissions();
    });
  },
  computed: {
    ...mapState('course', ['course', 'hasLiveClasses', 'enrollment']),
    ...mapState('member', ['member']),
    showMore() {
      return this.enrollees?.meta.hasMore;
    },
    permissions() {
      return this.course?.permissions.enrollments;
    },
    isAdmin() {
      return this.member?.isAdmin;
    },
    isSuperUser() {
      return this.member?.isSuperUser;
    },
    allSelected() {
      return Boolean(this.enrollees.data) && this.selected.size === this.enrollees.data.length;
    },
    loading() {
      return this.requests.enrollees?.loading;
    },
    searchApplied() {
      return Boolean(this.lastSearch) && this.searchTerm == this.lastSearch;
    },
    isAdminOrCourseInstructorOrStaff() {
      return (
        this.member?.isAdmin ||
        this.course.educators?.instructors?.includes(this.member?.id) ||
        this.course.educators?.staff?.includes(this.member?.id)
      );
    },
  },
  methods: {
    async list() {
      this.error = false;

      if (this.permissions.view) {
        try {
          const params = {
            limit: this.limit,
            offset: this.offset,
            order: this.sort,
            status: this.status || undefined,
            flagged: this.flagged || undefined,
            q: this.searchTerm,
          };
          await this.paginate({
            api: (config) => courseAPI.listEnrollees(this.course.id, config),
            name: 'enrollees',
            params,
            cancel: true,
            accumulate: false,
          });

          this.selected = new Set();
          this.lastSearch = this.searchTerm;
          this.maxPage = Math.ceil(this.enrollees.meta.totalRecords / this.limit);
        } catch (error) {
          this.error = true;
        }
      }
    },
    onPageChanged(page) {
      this.page = page;
      this.offset = (page - 1) * this.limit;

      this.list();
    },
    selectAll() {
      if (this.allSelected) {
        this.selected = new Set();
      } else {
        const allEnrollees = this.enrollees.data.map((enrollee) => enrollee.memberID);

        this.selected = new Set(allEnrollees);
      }
    },
    onTextSearch() {
      this.offset = 0;
      this.page = 1;

      this.list();
    },
    resetSearchTerm() {
      this.searchTerm = '';
      this.offset = 0;
      this.page = 1;

      this.list();
    },
    onFilterSelected(filter, value) {
      if (this[filter] === value) {
        this[filter] = '';
      } else {
        this[filter] = value;
      }
      this.onFiltersChanged();
    },
    onFiltersChanged() {
      this.offset = 0;
      this.page = 1;
      this.list();
    },
    clearFilters() {
      this.status = '';
      this.flagged = false;
      this.onFiltersChanged();
    },
    onBulkActionSuccess(enrollees) {
      enrollees.forEach((enrollee) => this.onRowUpdated(enrollee));
    },
    onRowUpdated(enrollee) {
      this.enrollees.data = this.enrollees.data.map((e) => (e.memberID === enrollee.memberID ? enrollee : e));
    },
    onShowProgressModal({ enrollee }) {
      this.$modal.show('enrollee-progress-modal', { enrollee });
    },
    onRowSelected(id) {
      this.selected.add(id);
      this.selected = new Set(this.selected);
    },
    onRowUnselected(id) {
      this.selected.delete(id);
      this.selected = new Set(this.selected);
    },
    onBulkError(count) {
      this.bulkErrors = count;

      this.list();
    },
    closeImportDetailsDialog() {
      this.openImportDetailsDialog = false;
      (document.getElementById('import-csv-file-btn') as HTMLInputElement).value = '';
    },
    closeImportResultDialog() {
      this.openPassResultDialog = false;
      (document.getElementById('import-csv-file-btn') as HTMLInputElement).value = '';
    },
    async importCSV() {
      document.getElementById('import-csv-file-btn').click();
    },
    async handleMarkEnrollment({ detail: { members, status, reviewComment } }) {
      const response = await courseAPI.updateEnrollmentsStatus(
        {
          members,
          reviewComment,
          status,
        },
        this.course.id
      );

      this.openImportDetailsDialog = false;

      const {
        data: { totalAttemptedCount, successCount, failedCount, reportURL },
      } = response;

      this.totalEnrollmentUpdateAttempted = totalAttemptedCount;
      this.successEnrollmentUpdate = successCount;
      this.failedEnrollmentUpdate = failedCount;
      this.enrollmentUpdateReportUrl = reportURL;

      this.openPassResultDialog = true;
    },
    async submitFile(event) {
      if (!this.isSuperUser && !this.isAdmin) {
        return;
      }
      this.importLoading = true;
      const formData = new FormData();
      formData.append('file', event.target.files[0]);
      const { data } = await courseAPI.importEnrolleesCSV(formData, this.course.id);

      const enrollmentData = data[0];
      this.enrollmentJson = JSON.stringify(enrollmentData);
      this.importLoading = false;
      this.reportUrl = enrollmentData.reportURL;
      this.openImportDetailsDialog = true;
    },
    async exportCSV() {
      if (this.isAdminOrCourseInstructorOrStaff) {
        this.exportLoading = true;

        try {
          const { data, headers } = await courseAPI.exportEnrolleesCSV(this.course.id);
          const fileURL = window.URL.createObjectURL(new Blob([data]));
          const fileLink = document.createElement('a');
          const fileName = headers['content-disposition'].split('=')[1].split('"')[1];

          fileLink.href = fileURL;
          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
        } catch (error) {
          this.exportError = true;
        }

        this.exportLoading = false;
      }
    },
    checkPermissions() {
      // R E D I R E C T   U N A U T H O R I Z E D   T O   A B O U T
      // Doesn't allow unauthorized users to navigate to manage page
      if (!this.permissions.view) {
        this.$router.push(
          this.rDecor({
            name: 'course-about',
            params: {
              vanityURL: this.course.vanityURL,
            },
          })
        );
      }
    },
  },
};
